
import { Link, useOutletContext } from "react-router-dom";

import Data_migration from "../../../Assets/Data_migration.png";
import WareHouse from "../../../Assets/WareHouse (2).png";
import Incident_mangemenet from "../../../Assets/Incident_mangement.png";
import ERP_tool from "../../../Assets/ERP_tool.png";
import { useScrollAnimation } from "../../../utils/Utils";
import About from "../../../Assets/AboutUspng.png"
import PurposeSection from "./AboutUs/OurOverview";
import ConsultingImpactShowcase from "./AboutUs/Clients";
import Overview from "../services/WebApplications/Overview";
const AboutUs = () => {
  const { linkClicked } = useOutletContext();
  useScrollAnimation();
  return (
    <div>
       <div className="w-full h-auto max-w-full m-auto">
      <video 
        src="https://ik.imagekit.io/kqumni8l2/logo%20reveal%20/ptkcs%20logo%202_4.mp4?updatedAt=1746009125412"
        className="w-full h-auto " 
        preload="metadata" 
        autoPlay 
        muted 
          playsInline
          loop={true}
      >
        Your browser does not support the video tag.
      </video>
      </div>

      <section>
        <PurposeSection/>
      </section>

      <section>
        <ConsultingImpactShowcase />  
        </section>
     
      <section>
        <Overview/>
     </section>
 
   
    </div>
  );
};

export default AboutUs;
